module.exports = __webpack_public_path__ + "img/module_ccgl_icon.81570f80.png";